import { Component } from '@angular/core';
import { SetupGuideStep } from '../setup-guide/setup-guide.component';

/**
 * Page wrapper for the QuickBooks integration settings.
 *
 * Hosts the settings form alongside the shared setup guide inside the standard
 * configuration page shell.
 */
@Component({
  selector: 'app-integration-quickbooks',
  templateUrl: './integration-quickbooks.component.html',
  styleUrls: ['./integration-quickbooks.component.css'],
})
export class IntegrationQuickbooksComponent {
  setupSteps: SetupGuideStep[] = [
    {
      num: 1,
      title: 'Connect to QuickBooks',
      body: `Click <strong>Connect to QuickBooks</strong>. You'll sign in at Intuit, choose your
             company, and be returned here connected. There is nothing to copy from Intuit: the
             app credentials are already set up for you.`,
      open: true,
    },
    {
      num: 2,
      title: 'Map your accounts & sync',
      body: `Set your income, payments, discount, and interest accounts, switch on
             <strong>Enable QuickBooks for this studio</strong>, save, then click
             <strong>Sync Now</strong> to send existing records.`,
    },
    {
      alt: true,
      title: 'Disconnecting',
      body: `Click <strong>Disconnect</strong> to revoke access. Your settings stay saved so you
             can reconnect later.`,
    },
  ];
}
